<template>
  <div class="head" id="head">
    <img src="../assets/logo.png" class="logo">
    <div class="m_nav_btn menubtn" v-on:click="opennav"><div></div></div>
   <div class="daohang">
    <div class="lanmu" v-for="l in list">
      <router-link  :to="l.href"><span class="btn1 btn3 cp_hide" v-on:click="opennav">{{l.title}}</span><span></span></router-link>
      <ul class="lanmu_ul" v-if="l.ul" >
        <li v-for="i in l.ul" v-on:click="opennav"><router-link  :to="i.href" >{{i.title}}</router-link></li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'heaDer',
  data:function(){
    return {
      list:[
        {
          title:'首页',
          href:"/",
          ul:[]
        },
        {
          title:'品牌故事',
          href:"/storyCsrs",
          ul:[
            {
              title:"创始人说",
              href:"/storyCsrs",
            },
            {
              title:"燕铺介绍",
              href:"/storyYpjs",
            }
          ]
        },
         {
          title:'明星产品',
          href:"/starGyxl",
          ul:[
            {
              title:"干燕系列",
              href:"/starGyxl",
            },
            //{
            //  title:"鲜享系列",
            //  href:"/starXxxl",
            //},
            // {
            //   title:"面膜系列",
            //   href:"/starMMxl",
            // },
            {
              title:"鱼胶系列",
              href:"/starYjxl",
            },
            {
              title:"阿胶系列",
              href:"/starEjxl",
            },
            {
              title:"胶原蛋白系列",
              href:"/starJydbxl",
            }
          ]
        },
         {
          title:'顾客口碑',
          href:"/praise"
        },
        {
          title:'燕铺讲堂',
          href:"/forumYpbb",
          ul:[
            {
              title:"燕窝辨别",
              href:"/forumYpbb",
            },
            {
              title:"燕窝食谱",
              href:"/forumYpsp",
            }
          ]
        },
        {
          title:'会员中心',
          href:"/vipHyjj",
          ul:[
            {
              title:"会员见证",
              href:"/vipHyjj",
            },
            {
              title:"会员福利",
              href:"/vipHyfl",
            }
          ]
        },
        {
          title:'防伪查询',
          href:"/check"
        },
        ]
    }
  },
  methods:{
			opennav:function(){
        if(document.body.clientWidth<768){
        $(".daohang").slideToggle("slow");
        $(".head").toggleClass("onav")
        }
      },
      
	}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head {
    width: 100%;
    height: 140px;
    margin: auto;
}
.logo {
    display: block;
    cursor: pointer;
    margin: 10px auto 0;
}
.daohang {
    display: flex; 
    margin: 30px auto 0;
    width: 945px;
    position: relative;
    z-index: 10;
    justify-content: center;
}
.lanmu {
  position: relative;
    font-size: 0;
    width:130px;
}
.lanmu a>span:last-child{ width: 2px; height: 20px; display: block; background: #000; position:absolute; right: 0; top: 14px;}
.lanmu a>span:first-child {
    font-size: 20px;
    display: block;
    margin: 0 auto;
    width: 120px;
    padding: 8px 0;
    text-align: center;
}
.lanmu:last-child a span:last-child{display: none}
.lanmu_ul {
    display: none;
    position: relative;
    z-index: 10;
    background: rgba(252,247,239,71);
}
.lanmu_ul li {
    margin-left: 0px !important;
    font-size: 18px;
    display: block;
    cursor: pointer;
}
.lanmu_ul li a {
    display: block;
    width: 120px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    padding-bottom: 5px;
}
.lanmu:hover .btn3{
    background: rgba(252,247,239,71);
   
  }
  .lanmu:hover .btn3::after{content: ""; display: block; width: 90%; height: 1px; background: #999; margin:10px auto 0;}
  .lanmu:hover .lanmu_ul{
    display: block;
  }
  .lanmu_ul li a:hover{
   background: rgba(252,247,239,71);
  }
  .m_nav_btn{ display: none;}
  .menubtn{ width: 100px;  height: 100px;}
.menubtn>div{ width: 60px;  margin:47px auto 0; height: 6px;  background: rgba(63,58,57,1); border-radius:3px ; position: relative;}
.menubtn>div:before,.menubtn>div:after{ content: ''; width: 100%; height: 6px;background: rgba(63,58,57,1); border-radius:3px ; display: block; position: absolute; left: 0;transition:all 0.5s;
-moz-transition: all 0.5s;	/* Firefox 4 */
-webkit-transition: all 0.5s;	/* Safari 和 Chrome */
-o-transition: all 0.5s;	
}
.menubtn>div:before{ top:-20px;
transform-origin:0 0;
-ms-transform-origin:0 0; 		
-webkit-transform-origin:0 0;	
-moz-transform-origin:0 0;		
-o-transform-origin:0 0;
transform: rotate(0deg);
-ms-transform: rotate(0deg); 		/* IE 9 */
-webkit-transform: rotate(0deg);	/* Safari 和 Chrome */
-moz-transform: rotate(0deg);		/* Firefox */
-o-transform: rotate(0deg);	}
.menubtn>div:after{ bottom:-20px;
transform-origin:0 6px;
-ms-transform-origin:0 6px; 		
-webkit-transform-origin:0 6px;	
-moz-transform-origin:0 6px;		
-o-transform-origin:0 6px;
transform: rotate(0deg);
-ms-transform: rotate(0deg); 		/* IE 9 */
-webkit-transform: rotate(0deg);	/* Safari 和 Chrome */
-moz-transform: rotate(0deg);		/* Firefox */
-o-transform: rotate(0deg);	}
.onav .menubtn>div{ background: rgba(63,58,57,0);}
.onav .menubtn>div:before{
	transform: rotate(45deg);
-ms-transform: rotate(45deg); 		/* IE 9 */
-webkit-transform: rotate(45deg);	/* Safari 和 Chrome */
-moz-transform: rotate(45deg);		/* Firefox */
-o-transform: rotate(45deg);		/* Opera */
}
.onav .menubtn>div:after{ 
transform: rotate(-45deg);
-ms-transform: rotate(-45deg); 		/* IE 9 */
-webkit-transform: rotate(-45deg);	/* Safari 和 Chrome */
-moz-transform: rotate(-45deg);		/* Firefox */
-o-transform: rotate(-45deg);	}
  .hidden-pc{ display:none !important;}
  .hidden-mb{ display:block !important;}
  @media(max-width: 750px) {
    .hidden-pc{ display: block !important;}
    .hidden-mb{ display: none !important;}
    .daohang{ width: 100%; top: 110px;left: 0; margin: 0;
    height: calc(100vh - 110px);height: -webkit-calc(100vh - 110px);
    position: absolute;
    display: none;
    background: rgba(0,0,0,0.72);}
    .logo{ width: 340px; margin-left: 30px; float: left; margin-top: 35px;}
    .m_nav_btn{ display: block; float:right;}
    .head{ height: 110px; background: #fff; z-index: 999;  position: fixed; left: 0; top: 0;}
    .lanmu{ width: 100%; height: 80px; line-height: 80px}
    .lanmu a>span:last-child{ background: #fff; display: none}
    .lanmu a>span:first-child{font-size:32px; color: #fff; width: 200px; float: left; padding: 0;}
    .lanmu_ul{ float:left; background: none;}
    .onav .lanmu_ul{ display: block;}
    .lanmu_ul li{ float: left;}
    .lanmu_ul li a{font-size:26px; color: #fff; width: 200px; height: 60px; line-height:60px; border-radius: 10px; border: 2px #eee solid; margin: 8px 15px; padding: 0;  }
    .lanmu_ul li a:hover { background: none}
    .lanmu:hover .btn3{background: none;}
    .lanmu:hover .btn3::after{content: ""; display: none;}
  
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue